import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
	selector: 'app-proceed-action-modal',
	templateUrl: './proceed-modal.component.html',
	styleUrls: ['./proceed-modal.component.css']
})
export class ProceedModalComponent implements OnInit {
	@Input() action: {
		callback?: Function
		message?: string;
		buttonLabel?:string;
		title?: string
	}
	ngOnInit() {

	}
	display: boolean = false
	constructor () {

	}
	onCallback() {
		if(this.action.callback)
			this.action.callback()
	}
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/proceed-modal/proceed-modal.component.ts